import _get from 'lodash/get';
import {
  FormTemplateQuestion,
  FormTemplateQuestionFieldsKindEnum,
} from 'graphql-common';
import { Values } from '@lib/interfaces/form';

type Args = {
  formTemplateVersionData: Values;
  isViewLocked: boolean;
  isFullAdmin: boolean;
};

// Hide questions whose every field is a Document when EDM is locked and
// the user can't upgrade the plan — there's nothing meaningful to render.
export default function getVisibleQuestions({
  formTemplateVersionData,
  isViewLocked,
  isFullAdmin,
}: Args): FormTemplateQuestion[] {
  const rawQuestions = _get(
    formTemplateVersionData,
    'questions',
    [],
  ) as FormTemplateQuestion[];

  if (!isViewLocked || isFullAdmin) {
    return rawQuestions;
  }

  return rawQuestions.filter((question) =>
    question.fields?.some(
      ({ kind }) => kind !== FormTemplateQuestionFieldsKindEnum.Document,
    ),
  );
}
